import { selectFromDriverSubscription } from '../models';
import { SubscriptionHandler } from '../utils/createSubscription';
import DriverQuery from '../queries/drivers/DriverQuery';
import DeletedDriverProfileQuery from '../queries/drivers/DeletedDriverProfileQuery';

const selector = selectFromDriverSubscription()
  .driverAddedDto(b => b.driver(DriverQuery))
  .driverEditedDto(b => b.driver(DriverQuery))
  .driverInviteAcceptedDto(b => b.driver(DriverQuery))
  .driverProfileDeletedDto(b => b.driver(DeletedDriverProfileQuery))
  .toString();

export default (): SubscriptionHandler => ({
  name: 'DriverSubscription',
  selector,
  events: new Map(Object.entries({
    DriverAddedDto: [],
    DriverEditedDto: [],
    DriverInviteAcceptedDto: [],
    DriverProfileDeletedDto: [],
  })),
  onError(error: Error) {
    console.error('DriverSubscription Error, check if websocket client initialized', JSON.stringify(error));

  },
});
